import { render, staticRenderFns } from "./PreviewClip.vue?vue&type=template&id=18dcd444&scoped=true&"
import script from "./PreviewClip.vue?vue&type=script&lang=js&"
export * from "./PreviewClip.vue?vue&type=script&lang=js&"
import style0 from "./PreviewClip.vue?vue&type=style&index=0&id=18dcd444&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dcd444",
  null
  
)

export default component.exports